export interface SystemPromptSegments {
  identity: string;
  behavioral: string;
  context: string;
}

export function assembleSystemPrompt(segments: SystemPromptSegments): string {
  return [segments.identity, segments.behavioral, segments.context]
    .filter(s => s.length > 0)
    .join('\n\n');
}

export function buildContextSegment(params: {
  entityName?: string;
  projectName?: string;
}): string {
  const {entityName, projectName} = params;
  if (entityName && projectName) {
    return `Current workspace: ${entityName}/${projectName}`;
  }

  if (entityName) {
    return `Current workspace: ${entityName}`;
  }

  return '';
}
